<template>
  <app-layout :title="``">
    <template #header>
      <div class="flex w-full justify-between items-center">
        <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none" v-html="title">
        </h2>
      </div>
    </template>

    <div class="mx-auto py-4">
      <div class="flow-root">
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <table class="min-w-full divide-y divide-slate-300">
              <thead>
                <tr>
                  <th scope="col" class="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                    <span class="sr-only">Edit</span>
                  </th>
                  <th scope="col"
                    class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-slate-900 sm:pl-0">
                    SEO Image
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    Name
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    URL
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-slate-900">
                    SEO Title
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-200 bg-white">
                <tr v-for="item in modelList.data" :key="item.id">
                  <td class="whitespace-nowrap py-2 px-0">
                    <EditButton :href="route(`${prefixRoute}.show`, item.id)" />
                  </td>
                  <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-slate-500 sm:pl-0">
                    <div class="flex items-center">
                      <img v-if="item.image" :src="item.image" loading="lazy"
                        class="border border-slate-200 rounded-[4px] w-[130px] h-[70px] object-cover box-content"
                        alt="SEO Image" />
                      <div v-else
                        class="border border-slate-200 rounded-[4px] w-[130px] h-[70px] bg-orange-50 flex items-center justify-center text-xl font-bold">
                        ⚠️
                      </div>
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm font-medium text-slate-900">
                    <div class="max-w-[150px] truncate overflow-hidden" :title="item.name">
                      {{ item.name }}
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-slate-900">
                    <div class="max-w-[200px] truncate overflow-hidden" :title="`https://shuka.design/${item.url}`">
                      <a :href="`https://shuka.design/${item.url}`" target="_blank">{{ item.url }}</a>
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-slate-500">
                    <div class="max-w-[250px] truncate overflow-hidden" :title="item.seo_title">
                      {{ item.seo_title }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mt-[10px] md:mt-[20px]">
      <ActivityLogGroup modelClass="page" />
    </div>

  </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import EditButton from '@/Components/Tables/EditButton.vue';
import ActivityLogGroup from '@/Components/ActivityLogGroup.vue';

defineProps({
  modelList: Object,
  prefixRoute: String,
  title: String,
});
</script>
